import { Record } from 'immutable';
import { ActiveFleet, OpenedAgreementsStats, Revenue, Utilization, vehicleBlockers } from 'services/resources';

const defaultBlockers = Object.values(vehicleBlockers).map((value) => {
  return { [value]: 0 };
});

const defaultActiveFleetValues: ActiveFleet = {
  available: 0,
  departingToday: 0,
  onLoan: 0,
  returningToday: 0,
  blockers: defaultBlockers,
};

const defaultRevenueValues: Revenue = {
  grossRevenue: [],
  netRevenue: [],
  stripeRevenue: [],
};

const defaultOpenedAgreementsValue: OpenedAgreementsStats = {
  totalOpenedAgreements: 0,
  openedAgreements: [],
};

const defaultUtilizationMetricsValues = {};

export interface ActiveFleetState {
  loading: boolean;
  values: ActiveFleet;
}

export interface RevenueState {
  loading: boolean;
  values: Revenue;
}

export interface OpenedAgreementsState {
  loading: boolean;
  values: OpenedAgreementsStats;
}

export interface UtilizationMetricsState {
  loading: boolean;
  values: Utilization;
}

const defaultActiveFleetState: ActiveFleetState = {
  loading: false,
  values: defaultActiveFleetValues,
};

const defaultRevenueState: RevenueState = {
  loading: false,
  values: defaultRevenueValues,
};

const defaultOpenedAgreementsState: OpenedAgreementsState = {
  loading: false,
  values: defaultOpenedAgreementsValue,
};

const defaultUtilizationMetricsState: UtilizationMetricsState = {
  loading: false,
  values: defaultUtilizationMetricsValues,
};

export const activeFleetFactory = Record(defaultActiveFleetState);

export const revenueFactory = Record(defaultRevenueState);

export const AgreementsStatsFactory = Record(defaultOpenedAgreementsState);

export const UtilizationDataFactory = Record(defaultUtilizationMetricsState);

export interface DashboardState {
  activeFleet: Record<ActiveFleetState>;
  revenue: Record<RevenueState>;
  agreements: Record<OpenedAgreementsState>;
  utilization: Record<UtilizationMetricsState>;
}

export const DashboardStateFactory = Record<DashboardState>({
  activeFleet: activeFleetFactory(),
  revenue: revenueFactory(),
  agreements: AgreementsStatsFactory(),
  utilization: UtilizationDataFactory(),
});
